import actionTypes from '../constants/action-types';

const setActiveTool = (id) => ({
  type: actionTypes.SET_ACTIVE_TOOL,
  payload: { id },
});

export default setActiveTool;
